import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { SnackBarComponent } from '@app/shared/components/snack-bar/snack-bar.component';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  showInfo(message: string): void {
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration: 1500,
      data: {
        message: message,
        icon: 'custom:alert-btn',
      },
      horizontalPosition: 'right',
    });
  }

  showError(message?: any, duration = 5000): void {
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration: duration,
      data: {
        message:
          this.getServerErrorMessage(message).replace(/_/g, ' ') ||
          'Server Error',
        icon: 'custom:attention-btn',
      },
      horizontalPosition: 'right',
    });
  }

  getServerErrorMessage(error: any): string {
    if (!error) {
      console.log(error);
      return 'Server Error';
    }

    if (typeof error === 'string') {
      return error;
    }

    const keys: Array<string> = Object.keys(error);
    if (keys.includes('originalError')) {
      return this.getServerErrorMessage(error.originalError);
    }
    if (keys.includes('hint')) {
      return error.hint;
    }
    if (!keys.includes('originalError') && keys.includes('message')) {
      return error.message;
    }
    let message: string;
    for (const key of keys) {
      if (key === 'error') {
        return error[key];
      }
      if (key === 'hint') {
        return error[key];
      }
      if (typeof error === 'string') {
        message = error[key];
        return message;
      } else {
        this.getServerErrorMessage(error[key]);
      }
    }
    return message;
  }
}
